/* @flow */
import React from 'react';
import Authorization from './Authorization';
import { permittedProjects } from './permissions';

export type AuthorizedProps = {
  permissions: [string],
  children: any
}

export default function Authorized({
  permissions,
  children
}: AuthorizedProps): React.Element {
  return (
    <Authorization
      predicate={ userPrivileges => permittedProjects(userPrivileges, permissions).length > 0 }
    >
      { children }
    </Authorization>
  );
}
